import { getSelfonboardingProcessedRequests } from "../api/selfonboardingHttpClient";
export const useProcessedRequestsGrid = () => {
  return { fetchGridData: getSelfonboardingProcessedRequests };
};
